import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router'
import { useEffect } from 'react'

import { queryClient } from '@/api/queryClient'
import { useApplyTheme } from '@/lib/theme'
import { connectAuthToHttpClient, useAuthStore } from '@/features/auth/stores/authStore'
import { router } from '@/routes/router'
import { Toaster } from '@/components/ui/Toaster'
import { TooltipProvider } from '@/components/ui/Tooltip'

// Koblingen mellem HTTP-klienten og auth-storen laves ved modulindlæsning, så
// den er på plads før det allerførste kald — også det, der genopretter sessionen.
connectAuthToHttpClient()

export function App() {
  const initialise = useAuthStore((state) => state.initialise)

  // Temaet skal gælde hele appen, også login og de offentlige delelinks —
  // derfor her og ikke inde i skallen.
  useApplyTheme()

  // Access tokenet ligger kun i hukommelsen og overlever ikke en genindlæsning.
  // Ved opstart forsøger vi derfor at forny det via refresh token-cookien.
  useEffect(() => {
    void initialise()
  }, [initialise])

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <RouterProvider router={router} />
        <Toaster />
      </TooltipProvider>
    </QueryClientProvider>
  )
}
